
import {
    SEARCH_OPEN_ACTION_TYPE,
    SEARCH_OPERATION_ACTION_TYPE
} from '../sagas/search';

import {
    REFRESH_PROJECT_ACTION_TYPE,
    GET_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    params: null,
    searchResult: null
};

export default function createReducer() {
    const loaderReducer = createLoaderReducer(SEARCH_OPERATION_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case SEARCH_OPEN_ACTION_TYPE:
                return {
                    ...initialState
                };

            case SEARCH_OPERATION_ACTION_TYPE.LOADING:
                return {
                    ...state,
                    searchResult: null
                };

            case SEARCH_OPERATION_ACTION_TYPE.SUCCESS:
                return {
                    ...loaderReducer(state, action),
                    ...action.data.result
                };

            case REFRESH_PROJECT_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
